class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });

    this.bindInnerEvents();
    this.setHeaderCartIconAccessibility();
  }

  bindInnerEvents() {
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink || cartLink.dataset.cartDrawerBound === 'true') return;

    cartLink.dataset.cartDrawerBound = 'true';
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
      window.ksCartGoalSync?.(this);
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');

        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

        if (containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling?.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement?.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerSectionHtml = parsedState.sections?.['cart-drawer'];
    const targetCartDrawer = document.getElementById('CartDrawer');

    if (drawerSectionHtml && targetCartDrawer) {
      const parsed = new DOMParser().parseFromString(drawerSectionHtml, 'text/html');
      const sourceCartDrawer = parsed.querySelector('#CartDrawer');

      if (sourceCartDrawer) {
        targetCartDrawer.innerHTML = sourceCartDrawer.innerHTML;
      }
    }

    const bubbleHtml = parsedState.sections?.['cart-icon-bubble'];
    if (bubbleHtml) {
      const parsedBubble = new DOMParser().parseFromString(bubbleHtml, 'text/html');
      const sourceBubble = parsedBubble.querySelector('.shopify-section') || parsedBubble.querySelector('#cart-icon-bubble');
      const targetBubble = document.getElementById('cart-icon-bubble');

      if (sourceBubble && targetBubble) {
        targetBubble.innerHTML = sourceBubble.innerHTML;
        targetBubble.dataset.cartDrawerBound = 'false';
      }
    }

    this.productId = parsedState.id;
    this.querySelector('.drawer__inner')?.classList.remove('is-empty');

    this.bindInnerEvents();
    this.setHeaderCartIconAccessibility();
    window.ksCartGoalSync?.(this);

    setTimeout(() => {
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const target = parsed.querySelector(selector);
    return target ? target.innerHTML : null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

window.ksCartDrawerRebind = () => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  drawer.bindInnerEvents();
  drawer.setHeaderCartIconAccessibility();
  window.ksCartGoalSync?.(drawer);
};

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems);
}